import ApprovedPage from "./ApprovedPage";
export default ApprovedPage;
